import React from 'react';
import ChefServicesList from '../chef/ChefServicesList';
import SVGChevron from '../../svg/Chevron';

class ChefServices extends React.Component {
  state = {
    isPastOpen: false,
    isPromoOpen: false
  };

  render() {
    const { title = 'Services' } = this.props;
    return (
      <div className="cms__section chef-services">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">{title}</h3>
          </div>
        </div>
        <div className="cms__section-body">
          {this.renderUpcomingServices()}
          {this.renderPastServices()}
          {this.renderPastServicesToggle()}
        </div>
      </div>
    );
  }

  renderUpcomingServices() {
    return (
      <div className="chef-services__upcoming">
        <h4 className="h4">Upcoming</h4>
        <ChefServicesList
          chef={this.props.chef}
          filter="upcoming"
          columns={this.props.columns}
          perPage={10}
          zipMap={this.props.zipMap}
        />
      </div>
    );
  }

  renderPastServices() {
    return this.state.isPastOpen ? (
      <div className="chef-services__past">
        <h4 className="h4">Past</h4>
        <ChefServicesList
          chef={this.props.chef}
          filter="past"
          columns={this.props.columns}
          zipMap={this.props.zipMap}
        />
      </div>
    ) : (
      ''
    );
  }

  renderPastServicesToggle() {
    return this.state.isPastOpen ? (
      <div
        className="a--blue a--center"
        onClick={() => this.setState({ isPastOpen: false })}
      >
        Collapse Past Services{' '}
        <span className="chev">
          <SVGChevron className="svg--flip-v" />
        </span>
      </div>
    ) : (
      <div
        className="a--blue a--center"
        onClick={() => this.setState({ isPastOpen: true })}
      >
        View Past Services{' '}
        <span className="chev">
          <SVGChevron />
        </span>
      </div>
    );
  }
}

export default ChefServices;



// WEBPACK FOOTER //
// ./src/components/chef/ChefServices.js